import { defineComponent, h, cloneVNode, VNode } from 'vue';

export const PagiflowSlide = defineComponent({
  name: 'PagiflowSlide',
  props: {
    asChild: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { attrs, slots }) {
    return () => {
      const defaultSlot = slots.default ? slots.default() : [];
      if (props.asChild && defaultSlot.length === 1) {
        return cloneVNode(defaultSlot[0] as VNode, attrs);
      }
      return h('div', attrs, defaultSlot);
    };
  },
});
